import script from "./WorkOrderList.vue?vue&type=script&lang=ts&setup=true&name=StandardList"
export * from "./WorkOrderList.vue?vue&type=script&lang=ts&setup=true&name=StandardList"

import "./WorkOrderList.vue?vue&type=style&index=0&id=6f732164&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f732164"]])

export default __exports__